import { z } from 'zod';
import type { JSONContent } from '@tiptap/core';
export const documentSchema = z.record(z.unknown()).transform((value) => value as JSONContent);
const reference = z.object({ threadId: z.string(), messageId: z.string() });
export const draftRequestSchema = z.object({
  recordId: z.string().optional(),
  reply: reference.optional(),
  replyAll: z.boolean().optional(),
  forward: reference.optional(),
});
const attachment = z.object({ name: z.string(), data: z.string() });
export const sendContentSchema = z.object({
  to: z.array(z.string()),
  cc: z.array(z.string()),
  bcc: z.array(z.string()),
  subject: z.string(),
  body: z.string(),
  document: documentSchema.optional(),
  attachments: z.array(attachment),
  recordId: z.string().optional(),
  reply: reference.optional(),
});
export const submissionSchema = z.object({
  action: z.literal('sendMail'),
  expectedUid: z.string().optional(),
  expectedSender: z.string().optional(),
  commandId: z.string(),
  content: sendContentSchema,
});
export const savedDraftSchema = z.object({
  request: draftRequestSchema,
  fields: z.record(z.string()).optional(),
  to: z.string(),
  cc: z.string(),
  bcc: z.string(),
  subject: z.string(),
  body: z.string(),
  document: documentSchema.optional(),
  attachments: z.array(attachment),
  submission: submissionSchema.optional(),
});
export const draftResponseSchema = z.object({
  revision: z.string().nullable(),
  draft: savedDraftSchema.nullable(),
});
export type SavedDraft = z.infer<typeof savedDraftSchema>;
export const decodeAttachments = (files: { name: string; data: string }[]) =>
  files.map(
    (file) => new File([Uint8Array.from(atob(file.data), (char) => char.charCodeAt(0))], file.name)
  );
export async function encodeAttachments(files: File[]) {
  if (files.length > 10 || files.reduce((n, file) => n + file.size, 0) > 5 * 1024 * 1024)
    throw new Error('Vælg højst 10 filer og samlet 5 MiB.');
  return Promise.all(
    files.map(async (file) => {
      const bytes = new Uint8Array(await file.arrayBuffer());
      let binary = '';
      for (let offset = 0; offset < bytes.length; offset += 8192)
        binary += String.fromCharCode(...Array.from(bytes.subarray(offset, offset + 8192)));
      return { name: file.name, data: btoa(binary) };
    })
  );
}
